namespace TabAurous.TaxHelper {

    export function GetTax(BaseItemTypeId: number, TaxGroupId: number) {

        var Rate: number[];
        let ServiceEndpoint = "/services/" + TabAurous.Common.TaxkHelperService.baseUrl + "/GetTax"

        $.ajax({
            type: "post",
            dataType: "json",
            async: false,
            url: ServiceEndpoint,
            data: {
                'BaseItemTypeId': BaseItemTypeId,
                'TaxGroupId': TaxGroupId
            },
            success: function (response) {

                if (response instanceof Object) {
                    var json = response;
                }
                else {
                    var json = $.parseJSON(response);
                }

                var output = json['result'];
                Rate = output;
            }.bind(this),
            error: function (jqxhr, textStatus, error) {
                var err = textStatus + ", " + error;
                alert("Error! " + err);
            }

        });

        return Rate;

    }

    export function IndianGST(HSN: any[], Amount: any[], Date: string, IsIGST: boolean, TaxRegistred: number) {

        var TaxDetail = [];

        for (let i = 0; i < HSN.length; i++) {
            try {
                var Tax = OMS.HsnTaxMasterRow.getLookup().items.filter(x => x.Code === HSN[i] && x.TaxGroup === Q.Authorization.userDefinition.TaxGroupId)[0];
            }
            catch (undefined) {
                Q.notifyWarning("Rate Not Defined for" + HSN[i]);
            }

            var TaxRate: number;
            var Tax1Rate: number;
            var Tax2Rate: number;
            var CessRate: number;
            var Cess1Rate: number;
            var Cess2Rate: number;

            if (Tax != undefined) {
                var netamt = Amount[i].toFixed(2);
                if (IsIGST) {

                    try {
                        TaxRate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax.TaxId && x.Date <= Date)[0].Rate;
                        if (Tax.CessId != undefined) {
                            CessRate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax.CessId && x.Date <= Date)[0].Rate;
                        }
                    }
                    catch (undefined) {
                        Q.notifyWarning("Tax rate not defined for current period, Tax is not calculated")                        
                    }

                    var TaxRow: Purchase.PurchaseTaxRow = {
                        TaxId: Tax.TaxId,
                        HSN: HSN[i],
                        NetAmount: netamt,
                        TaxRate: TaxRate,
                        TaxAmount: netamt * (TaxRate / 100),
                        CessId: Tax.CessId || 0,
                        CessAmount: (netamt * (TaxRate / 100)) * (CessRate / 100) || 0,
                        CessRate: CessRate || 0,
                        TaxLedgerId: Tax.TaxLedgerId,
                        CessLedgerId: Tax.CessLedgerId,
                        
                    }

                    TaxDetail.push(TaxRow);
                }
                else {

                    Tax1Rate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax.Tax1Id && x.Date <= Date)[0].Rate
                    Tax2Rate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax.Tax2Id && x.Date <= Date)[0].Rate

                    if (Tax.CessId != undefined) {
                        Cess1Rate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax.Cess1Id && x.Date <= Date)[0].Rate;
                        Cess2Rate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax.Cess2Id && x.Date <= Date)[0].Rate;
                    }

                    var TaxRow: Purchase.PurchaseTaxRow = {
                        HSN: HSN[i],
                        NetAmount: netamt,
                        TaxId: 0,
                        TaxRate: 0,
                        TaxAmount: 0,
                        
                        CessId: 0,
                        CessAmount: 0,
                        CessRate: 0,
                       
                        TaxLedgerId: Tax.TaxLedgerId,
                        CessLedgerId: Tax.CessLedgerId,
                    }



                    TaxDetail.push(TaxRow)
                }
            }
        }

        return TaxDetail;
    }

    export function NewTaxCalculation(HSN: any[], Amount: any[], date: string, IsIGST: boolean, TaxRegistred: number) {

        var TaxDetail = [];

        var Taxes = [];
        var Tax: OMS.HSNTaxDetailsRow[];

        var Country = parseInt(OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId].Country);
        var TaxGroupId = Q.Authorization.userDefinition.TaxGroupId
        for (let i = 0; i < HSN.length; i++) {
            try {

                switch (Country) {

                    case 101:
                        if (IsIGST)
                            Tax = OMS.HSNTaxDetailsRow.getLookup().items.filter(x => x.Code === HSN[i] && x.GroupId === TaxGroupId && x.IsInterState == true);
                        else
                            Tax = OMS.HSNTaxDetailsRow.getLookup().items.filter(x => x.Code === HSN[i] && x.GroupId === TaxGroupId && x.IsInterState == false);
                        break;

                    case 229:
                        Tax = OMS.HSNTaxDetailsRow.getLookup().items.filter(x => x.Code === HSN[i] && x.GroupId === TaxGroupId && x.IsInterState == false);
                        break;
                }

                
            }
            catch (undefined) {
                Q.notifyWarning("Tax Rate Not Defined ");
            }

            var TaxRate: number;


            if (Tax != undefined) {
                Q.reloadLookup(OMS.TaxRateHistoryRow.lookupKey);
                var netamt = Amount[i] > 0 ? Amount[i] : 0;

                for (var k = 0; k < Tax.length; k++) {

                    try {
                        TaxRate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax[k].TaxId && x.Date <= date)[0].Rate;
                    }
                    catch (undefined) {
                        Q.notifyWarning("Tax rate not defined for current period, Tax is not calculated")
                    }

                    var TaxRow: Purchase.PurchaseTaxRow = {
                        TaxId: Tax[k].TaxId,
                        TaxName: Tax[k].TaxName,
                        NetAmount: netamt,
                        TaxRate: TaxRate,
                        TaxAmount: netamt * (TaxRate / 100),
                        LedgerId: Tax[k].LedgerId,
                        OutputLedgerId: Tax[k].OutputLedgerId,
                        InputRCMLedgerId: Tax[k].InputRCMLedgerId,
                        OutputRCMLedgerId: Tax[k].OutputRCMLedgerId,
                        HSN: HSN[i]
                    }

                    if (TaxRate != undefined) {
                        TaxDetail.push(TaxRow); 
                    }                                         
                }
            }
        }
        return TaxDetail;
    }

    export function VoucherTaxCalculation(vouchertypeid: number, Amount: number, Date: string, oldTax: any[], IsIGST: boolean) {

        var TaxDetail = oldTax;

        try {
            var Tax = OMS.VoucherTaxDetailsRow.getLookup().items.filter(x => x.VoucherTypeId === vouchertypeid && x.GroupId === Q.Authorization.userDefinition.TaxGroupId);
        }
        catch (undefined) {
            Q.notifyWarning("Rate Not Defined");
        }

        var TaxRate: number;

        if (Tax != undefined) {
            var netamt = Amount;
            for (var k = 0; k < Tax.length; k++) {

                TaxRate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax[k].TaxId && x.Date <= Date)[0].Rate;


                if (TaxRate == undefined) {
                    Q.alert("Tax rate not defined for current period, Tax is not calculated")
                    break;
                }

                if (IsIGST) {
                    if (Tax[k].TaxType == "GST" && Tax[k].IsInterState == true) {
                        var TaxRow: Purchase.PurchaseTaxRow = {
                            TaxId: Tax[k].TaxId,
                            TaxName: Tax[k].TaxName,
                            TaxType: Tax[k].TaxType,
                            NetAmount: netamt,
                            TaxRate: Tax[k].TaxRate,
                            TaxAmount: netamt * (Tax[k].TaxRate / 100)
                        }

                        TaxDetail.push(TaxRow);
                    }

                }
                else {
                    if (Tax[k].TaxType == "GST" && Tax[k].IsInterState == false) {
                        var TaxRow: Purchase.PurchaseTaxRow = {
                            TaxId: Tax[k].TaxId,
                            TaxName: Tax[k].TaxName,
                            TaxType: Tax[k].TaxType,
                            NetAmount: netamt,
                            TaxRate: Tax[k].TaxRate,
                            TaxAmount: netamt * (Tax[k].TaxRate / 100)
                        }

                        TaxDetail.push(TaxRow);
                    }

                }
                if (Tax[k].TaxType != "GST" || Tax[k].TaxType != "TDS") {
                    var TaxRow: Purchase.PurchaseTaxRow = {
                        TaxId: Tax[k].TaxId,
                        TaxName: Tax[k].TaxName,
                        TaxType: Tax[k].TaxType,
                        NetAmount: netamt,
                        TaxRate: Tax[k].TaxRate,
                        TaxAmount: netamt * (Tax[k].TaxRate / 100)
                    }

                    TaxDetail.push(TaxRow);
                }
            }
        }
        return TaxDetail;
    }
}